module.exports = __webpack_public_path__ + "static/media/img_specs-classic.1bafb199.png";